import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const bookingsLastNameViewer = {
    autoComplete: 'family-name',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map